import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Marker } from 'react-leaflet';
import L from 'leaflet';
import onClickOutside from 'react-onclickoutside';
import {translate} from "react-i18next";

import { getLocationText } from '../../utils/geo';


const TYPES = ['start', 'end'];

@onClickOutside
class PointMarker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
    };
    this.openTooltip = this.openTooltip.bind(this);
    this.closeTooltip = this.closeTooltip.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
    this._mounted = false;
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  openTooltip() {
    this.setState({
      isActive: true,
    });
  }

  closeTooltip() {
    this.setState({
      isActive: false,
    });
  }

  handleClickOutside() {
    if (this._mounted && this.state.isActive) {
      this.setState({
        isActive: false,
      });
    }
  }

  render() {
    const { journey, type } = this.props;
    const key = type === 'start' ? 'start' : 'finish';
    const icon = L.divIcon({
      html: `<div class="map-point map-point-${type}">
              ${
                `<div class="map-point-tooltip">
                  <address>${getLocationText(journey.geoData[key])}</address>
                </div>`
              }
             </div>`,
    });
    const position = type === 'start' ?
      [journey.journey.stat.startLat / 10000000, journey.journey.stat.startLon / 10000000] :
      [journey.journey.stat.finishLat / 10000000, journey.journey.stat.finishLon / 10000000];

    return <div><Marker icon={icon} position={position} /></div>;
  }
}

PointMarker.propTypes = {
  type: PropTypes.oneOf(TYPES),
  journey: PropTypes.object,
};

export default PointMarker;



// WEBPACK FOOTER //
// ./src/components/JourneyMap/PointMarker.js